// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const SaveAndEditDynamicFilterModalContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-saveandeditdynamicfiltermodalcontainer" */ "./SaveAndEditDynamicFilterModalContainer")).then((bundle)=>{
        return {
            default: bundle.SaveAndEditDynamicFilterModalContainer
        };
    });
export const LazySaveAndEditDynamicFilterModalContainer = /*#__PURE__*/ lazy(SaveAndEditDynamicFilterModalContainerLazyLoader);
